import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

// Signed download links for a purchase invoice's PDFs, whichever month it came
// in. The project must be one whose expense tracking lists the invoice.
export const getPurchaseInvoicePdfUrls = async (projectId, invoiceId) => {
  const apiPath = `invoice/${projectId}/${invoiceId}/get-purchase-invoice-pdf-urls`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    // isLocalApiRequest: true,
  });

  const response = await axios(signedRequest);

  return response.data;
};
